import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import cn from 'classnames';

import { ListItem } from 'components/UI/Tailwind/ListItem';

type TDiv = JSX.IntrinsicElements['div'];

export interface Dropdown
  extends Pick<Required<TDiv>, 'children'>,
    Pick<TDiv, 'className'> {
  button: React.ReactNode;
  position:
    | 'top'
    | 'top-left'
    | 'top-right'
    | 'bottom'
    | 'bottom-left'
    | 'bottom-right';
  wrapperClassName?: TDiv['className'];
}

export function Dropdown({
  button,
  children,
  className,
  position,
  wrapperClassName,
}: Dropdown) {
  return (
    <Menu as="div" className={cn('relative leading-none', wrapperClassName)}>
      {button}
      <MenuItems
        className={cn(
          'absolute w-screen min-w-full max-w-max rounded-[6px] border border-gray-200 bg-white p-2 shadow-lg transition duration-100 ease-out focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0',
          {
            'left-0 mt-1 origin-top': position === 'top',
            'left-0 mt-1 origin-top-left': position === 'top-left',
            'right-0 mt-1 origin-top-right': position === 'top-right',
            'bottom-full left-0 mb-1 origin-bottom': position === 'bottom',
            'bottom-full left-0 mb-1 origin-bottom-left':
              position === 'bottom-left',
            'bottom-full right-0 mb-1 origin-bottom-right':
              position === 'bottom-right',
          },
          className,
        )}
        transition
      >
        {children}
      </MenuItems>
    </Menu>
  );
}

export const DropdownButton = MenuButton;

export const DropdownItem = ListItem;
